// Compare document content, excluding editor navigation and generated thumbnails.
export const recordEditorSignature = (payload) => {
  const { activeSectionId, filters, ...document } = payload;
  const temporaryKeys = new Set(["_preview_url", "_previewUrl", "_preview_source_code", "preview_url"]);
  const normalize = (value) => {
    if (Array.isArray(value)) return value.map(normalize);
    if (!value || typeof value !== "object") return value;
    return Object.fromEntries(Object.keys(value).sort()
      .filter((key) => !temporaryKeys.has(key) && key !== "activeIconRole")
      .map((key) => [key, normalize(value[key])]));
  };
  return JSON.stringify(normalize(document));
};
